export default __webpack_public_path__ + "6969bde8aed712d61bcea98b7c35e296.svg";